import { SUBMIT_CONTACT_US_DETAILS} from "../actionTypes";
import { addContactUsRequest } from "../../../api/contactUs/contactUs.service";

const request = () => ({ type: SUBMIT_CONTACT_US_DETAILS.REQUEST });
const failure = (error) => ({ type: SUBMIT_CONTACT_US_DETAILS.FAILURE, error });
const success = () => ({ type: SUBMIT_CONTACT_US_DETAILS.SUCCESS });

export const SubmitComment = (payload) => {
  return (dispatch, getState) => {
    dispatch(request());
    return addContactUsRequest(payload)
      .then((res) => {
        dispatch(success(res));
       // return Promise.resolve(true);
        return Promise.resolve({res:res,status:true});
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        //return Promise.resolve(false);
        return Promise.resolve({error:error?.message,status:false});
      });
  };
};